export default {
    videoSpeaker: {
        index01: '我是繁体',
    },
    // 公共
    common: {
        cancel: '取消',
        del: '確定',
    },
    //登录页面
    login: {
        welcomeUseAIBot: '歡迎使用AI百寶箱',
        useCode: '手機號登錄',
        useUserName: '帳號登錄',
        pleaseSetIphone: '請輸入香港手機號（無需 852 前綴）',
        pleaseSetCode: '請輸入驗證碼',
        getCode: '獲取驗證碼',
        noAccount: '沒有帳號，立即',
        register: '註冊',
        pleaseSetPassword: '請輸入密碼',
        login: '登錄',
        pleaseAgreeXieYi: '請選擇同意協議',
        alsoRead: '已閱讀並同意',
        and: '與',
        userAgreement: '用戶協議',
        privacyPolicy: '隱私政策',
        forgetPassWord: '忘記密碼',
        resetPassWord: '重設密碼',
        pleaseSetPassWord: '請輸入密碼',
        againPleaseSetPassWord: '再次輸入密碼',
        noResetPassWord: '無需重設密碼，立即',
        nowLogin: '登錄',
        confirm: '確認',
        firstTimeLogin: '首次登錄設定密碼',
        pleaseEnterMessage: '請完成安全驗證',
        pleaseSliderRight: '向右滑動完成驗證',
        messageFail:'驗證失敗',
        messageSuccess:'驗證成功',
        jiekouFiale: '驗證失敗次數過多，請稍後再試',
    },
    // 我的资产
    userInfoMesssage:{
        tipsleft:'檔案將最短暫存',
        tipsRighr:'小時，請及時下載'
    },
    // 网站首页
    homePage: {
        slogan1: '體驗全新AI科技工具',//体验全新AI科技工具
        slogan2: '釋放AI創作意願，激發無限創意可能',//释放AI创作灵感，激发无限创意可能
        slogan3: '立即體驗',//立即体验
        ALTreasureChest: 'AI百寶箱',//AI百宝箱
        greetings: '助你所想即所得',//助你所想即所得
        descrWords: '智能解析所想，一鍵生成佳作',//智能解析所想，一键生成佳作
        inspirationPictures: '靈感圖片',//灵感图片
        specialEffectsVideo: '特效視頻',//特效视频
        intelligentDialogue: '智能對話',//智能对话
        AIPPT: 'Al PPT',//Al PPT
        digitalHuman: '數字人',//数字人
        explore: '探索',//探索
        quickLogin: '快速登錄',//快速登录
        myCount: '我的帳戶',
        myAssets: '我的資產',
        loGout: '登出',
        totalPoInTs: '總AI豆',
        totalEarned: '累計獲得',
        totalSpent: '累計消耗',
        AIPoInTsNotEnough: 'AI豆不夠？充值增加更多',
        Recharge: '充值',
        spent: '消耗',
        earn: '獲得',
        Date: '日期 ',
        MobileNumber: '手機號',
        tools:'工具',
        Source: '來源',
        spentAIPoints: '消耗AI豆',
        earnedAIPoints: '獲得AI豆',
        allToTalPoints: '總AI豆',
        onlyThirtyMessage: '僅展示近60天內的紀錄，暫無紀錄',
        sureDel: '刪除資產',
        delInfo: '刪除後無法恢復，確定刪除？',
        all: '全部',
        Images: '圖片',
        Videos: "視頻",
        footer: '© 2025 中國移動香港有限公司版權所有',//© 2025 中国移动香港有限公司版权所有
        nothing:'暫無資產',//暂无资产
    },
    //支付页
    Payment: {
        headline: '通過充值獲得更多AI豆',//通过充值获得更多灵感点
        subheading: '溫馨提示：AI豆不可轉贈或提現，不支持退換貨或反向兌換提現',//温馨提醒：灵感点不可转赠或提现，不支持退换货或反向兑换提现
        canGenerate: '可生成',//可生成
        inspirationPictures: '張靈感圖片',//张灵感图片
        specialEffectsVideo: '個特效視頻',//个特效视频
        intelligentDialogue: '字智能對話',//字智能对话
        AIPPT: '個AI PPT',//个AI PPT
        digitalHuman: '個數字人視頻',//个数字人视频
        pay: '支付',//支付
    },
    //支付结果查询页
    RechargeInquiry: {
        topUpSuccessful: '充值成功',//充值成功
        topUpFailed: '充值失败',//充值失败
    },
    //AI对话
    AIDialog: {
        nowToalking:'最近對話',
        welcome:'歡迎使用',
        intelligentDialogue: '智能對話',// 智能对话
        startConversation: '開啟新對話',// 开启新对话
        helpTips: '需要幫助？儘管提問',// 需要帮助？尽管提问
        pleaseEnterMessage: '請輸入訊息',// 请输入消息
        deepThinking: '深度思考',// 深度思考
        newConversation: '新對話',// 新对话
        switchModel: '切換模型',//切换模型
        Rename: '重新命名',//重命名
        delete: '刪除',//删除
    },
    // 视频特效模板
    effectsTemplate:{
        selectTemplate:'選擇特效模板',
        clickReplace:'點擊替換圖片',
        UploadImage:'上傳圖片',
        texiao:"創意特效",
        WelcomeUse:'歡迎使用',
        EnhanceEffects:'特效增強',
        CreativeRender:'創意渲染',
        all:'全部',//全部
        fun:'趣味',//趣味
        transform:'變身',//变身
        creativity:'創意',//创意
        doll:'變身玩偶',// 变身玩偶
        pig:'召唤坐骑 - 猪',// 召唤坐骑 - 猪
        tiger:'召喚坐騎 - 老虎',// 召唤坐骑 - 老虎
        dragon:'召喚坐騎 - 龍',// 召唤坐骑 - 龙
        ikebana:'萬物生花',// 万物生花
        hug:'擁抱',// 拥抱
        embraceLove:'愛的擁抱',// 爱的拥抱
        manyWomen:'美女環繞',// 美女环绕
        manyHandsome:'帥哥環繞',// 帅哥环绕
        baby:'天賜寶寶',// 天赐宝宝
        emo:'emoji小人變身',// emoji小人变身
        dreamyDoll:'夢幻娃娃變身',// 梦幻娃娃变身
        babyCamera:'娃娃照相機',// 娃娃照相机
        worldWind:'我的世界風',// 我的世界风
        crystalBall:'裝進水晶球',// 装进水晶球
        catStarPeople:'貓星人的守護',// 猫星人的守护
        angelFigurine:'天使手辦變身',// 天使手办变身
        felt:'毛氈鑰匙扣變身',// 毛毡钥匙扣变身
        acrylic:'亞克力掛飾變身',// 亚克力挂饰变身
        instantCamera:'拍立得風',// 拍立得风
        collectibleToy:'潮玩手辦變身',// 潮玩手办变身
        tips01:'第一個區域點擊選擇模板，第二個區域點擊上傳圖片',
        uploadCheck:'請上傳 JPG 或 PNG 圖片，建議小於 5MB。'
    },


}
